import { MAX_SAMPLES_PER_PACK } from '@arpeggi/shared'
import { useParams } from 'react-router-dom'
import { useArpMedias } from '__legacy__/queries/arpMedia'
import { useSamplePack } from '../../../queries/samplePacks'
import CenteredLoadingAnimation from '../../core/CenteredLoadingAnimation'
import { SamplePackForm } from '../../internal/sample-packs/SamplePackForm'

export const EditSamplePack = () => {
  const params = useParams<{ id: string }>()
  const id = parseInt(params.id)
  const samplePackQuery = useSamplePack({ id })
  const samplePackSounds = useArpMedias({ samplePackId: id, perPage: MAX_SAMPLES_PER_PACK })
  const isLoading = samplePackQuery.isLoading || samplePackSounds.isLoading
  const flattenedSounds =
    samplePackSounds.data?.pages.flatMap((page) => page.data.map((sound) => sound)) || []

  return (
    <>
      {isLoading && <CenteredLoadingAnimation />}
      {!isLoading && <SamplePackForm samplePack={samplePackQuery.data} sounds={flattenedSounds} />}
    </>
  )
}
